export const isDev = process.env.NODE_ENV === 'development';
export const appVersion = process.env.NPM_PACKAGE_VERSION;
export const isIFrame = window.parent.location !== window.location;
export const sentryDSN = 'https://5dca564f77414630aef6c21e2e12d9ea@o197999.ingest.sentry.io/5548244';

export enum Steps {
  CartChangeError = 'CartChangeError',
  CartPresentmentHook = 'CartPresentmentHook',
  Hook = 'Hook',
  Chip = 'Chip',
  OrderConfirmation = 'OrderConfirmation',
  PL2GoChip = 'PL2GoChip',
  PL2GoHook = 'PL2GoHook',
  SelectCheckoutMethod = 'SelectCheckoutMethod',
  ShowVcc = 'ShowVcc',
  Hidden = 'Hidden',
}

export enum FrameTypes {
  Chip = 'chip',
  Hook = 'hook',
  Fullscreen = 'fullscreen',
}

export const StepSubSrcs = {
  [Steps.CartPresentmentHook]: 'cart-presentment-hook',
  [Steps.CartChangeError]: 'cart-change-error',
  [Steps.Hook]: 'hook',
  [Steps.Chip]: 'chip',
  [Steps.PL2GoChip]: 'pl2go-chip',
  [Steps.PL2GoHook]: 'pl2go-hook',
  [Steps.SelectCheckoutMethod]: 'select-checkout-method',
  [Steps.ShowVcc]: 'show-vcc',
  [Steps.Hidden]: 'hidden',
};

export enum SDataEventName {
  CheckoutSdata = 'ext700100',
  PL2GoSdata = 'ext700200',
}

export enum SubSrcs {
  Chip = 'chip',
  FindSavings = 'find-savings',
  PL2GoHook = 'hook',
  PL2GoHookAfterFS = 'hook-after-find-savings',
  PL2GoHookStandAlone = 'hook-standalone',
  PSB = 'psb',
  None = 'none',
  CashBackProposition = 'cash-back',
  CheckoutSecurelyProposition = 'checkout-securely',
  GetRewardedProposition = 'get-rewarded',
  MoreWaysToPayProposition = 'more-ways-to-pay',
  PurchaseProtectionProposition = 'purchase-protection',
  MultiProposition = 'multiple',
  GoldBurnProposition = 'gold-burn',
}

export enum SDataActions {
  BurnGoldHookPresentmentShown = 'burn-gold-hook-presentment-shown',
  BurnGoldModalPresentmentShown = 'burn-gold-modal-presentment-shown',
  CheckoutSuppressed = 'checkout-suppressed',
  Clicked = 'clicked',
  ClickedNativePaypalGuestButton = 'clicked-native-guest-button',
  ClickedPaypalButton = 'clicked-paypal-button',
  ClickedPaypalPayLaterButton = 'clicked-paypal-pay-later-button',
  ClickedStaticPaypalButton = 'clicked-static-paypal-button',
  Collapsed = 'collapsed',
  Expanded = 'expanded',
  NativePaypalGuestButtonShown = 'native-guest-button-shown',
  NativePaypalGuestPaymentApproved = 'native-guest-payment-approved',
  PaypalMemberPaymentApproved = 'paypal-payment-approved',
  PayLaterButtonShown = 'pay-later-button-shown',
  PaypalButtonShown = 'paypal-button-shown',
  PaypalPayLaterPaymentApproved = 'paypal-pay-later-payment-approved',
  Shown = 'shown',
  StaticPaypalButtonShown = 'static-paypal-button-shown',
  TryLater = 'user-try-later',
  UpgradeFacilitatorAccessTokenError = 'upgrade-facilitator-access-token-error',
  UpgradeFacilitatorAccessTokenSuccess = 'upgrade-facilitator-access-token-success',
  UserClosedCheckoutHook = 'user-closed-checkout-hook',
  UserDisabledCheckout = 'user-disabled-checkout',
  UserEligible = 'user-eligible',
  UserIneligible = 'user-ineligible',
}

export enum SDataPL2GoSubActions {
  AmountTooHigh = 'amount-too-high',
  AmountTooLow = 'amount-too-low',
  BrowserNotSupported = 'browser-not-supported',
  PaypalUserPrefix = 'paypal-',
  PresentmentUnavailable = 'presentment-unavailable',
  MerchantDisabled = 'merchant-disabled',
  SessionInitiationFailed = 'session-initiation-failed',
  SessionInitiationSuccessful = 'session-initiation-successful',
  SessionWindowRefocus = 'session-window-refocus',
  UserHidPL2GoHook = 'user-hid-pl2go-hook',
  UserDisabledPL2GoHook = 'user-disabled-pl2go-hook',
  UserInControlExperimentGroup = 'user-in-experiment-control-group',
  UserPassedEligibilityAmountKnown = 'user-passed-eligibility-amount-known',
  UserPassedEligibilityAmountUnknown = 'user-passed-eligibility-amount-unknown',
  VccCartDisabled = 'vcc-cart-disabled',
  VccDisabled = 'vcc-disabled',
}

export const imageRoot = 'https://cdn.joinhoney.com/images/checkout';
export enum ImageSrcs {
  BluePlus = 'blue-plus.svg',
  BuyerProtectionIcon = 'buyer-protection.svg',
  CardIconPaypalDark = 'cc-paypal-pay-later.svg',
  CardLogoAmex = 'card-logo-amex.svg',
  CardLogoDiscover = 'card-logo-discover.svg',
  CardLogoMastercard = 'card-logo-mastercard.svg',
  CardLogoPaypal = 'card-logo-paypal.svg',
  CardLogoVisa = 'card-logo-visa.svg',
  CCBlankIcon = 'cc-payment-icon.svg',
  CoinyWalk = 'coiny-walk.gif',
  DownArrowBottom = 'down-arrow-bottom.svg',
  GoldGCircle = 'gold-g-circle.svg',
  GoldGCircleGrey = 'gold-g-circle-grey.svg',
  GoogleAttribution = 'google-attribution.png',
  HoneyInitialBlack = 'honey-initial-black.svg',
  HoneySymbolBlack = 'honey-symbol-black.svg', // this one is slightly bigger
  HowItWorks = 'how-it-works.svg',
  LeftArrow = 'left-arrow.svg',
  PayPalHoney = 'paypal-honey-logo-orange.svg',
  PL2GoPayPalLogo = 'pl2go-paypal-logo.svg',
  PL2GoSchedule1 = 'pl2go-schedule-1.svg',
  PL2GoSchedule2 = 'pl2go-schedule-2.svg',
  PL2GoSchedule3 = 'pl2go-schedule-3.svg',
  PL2GoSchedule4 = 'pl2go-schedule-4.svg',
  PayPalInitials = 'paypal-initials.svg',
  PaypalInitialsWhite = 'paypal-initials-white.svg',
  PaypalLogo = 'paypal-logo.svg',
  RewardsIcon = 'rewards-icon.svg',
  SecureCheckoutIcon = 'secure-checkout-icon.svg',
  HoneyGoldPayPalColors = 'honey-gold-circle-pp-colors.svg',
  SixDots = 'six-dots.svg',
  TrashCan = 'trash-can.svg',
  TrophyRewardsCircle = 'trophy_rewards_circle.svg',
  WalletIcon = 'wallet-icon.svg',
  WarningSign = 'warning.svg',
  WhiteBlackHoneyInitial = 'white-black-honey-initial.svg',
}

export const ImageAlts = {
  [ImageSrcs.BluePlus]: 'Plus sign',
  [ImageSrcs.CardIconPaypalDark]: 'PayPal card icon dark blue',
  [ImageSrcs.CardLogoAmex]: 'American Express logo',
  [ImageSrcs.CardLogoDiscover]: 'Discover logo',
  [ImageSrcs.CardLogoMastercard]: 'Mastercard logo',
  [ImageSrcs.CardLogoPaypal]: 'PayPal logo',
  [ImageSrcs.CardLogoVisa]: 'Visa logo',
  [ImageSrcs.CCBlankIcon]: 'Credit/Debit card icon',
  [ImageSrcs.CoinyWalk]: 'Coiny walking animation',
  [ImageSrcs.DownArrowBottom]: 'Arrow pointing down towards bottom',
  [ImageSrcs.GoldGCircle]: 'Honey Gold circle',
  [ImageSrcs.GoldGCircleGrey]: 'Honey Gold circle',
  [ImageSrcs.GoogleAttribution]: 'Google logo',
  [ImageSrcs.HoneyInitialBlack]: 'Honey logo',
  [ImageSrcs.HowItWorks]: 'Banner with credit cards, gold coins, and Honey PayPal logos',
  [ImageSrcs.LeftArrow]: 'Go back',
  [ImageSrcs.PayPalHoney]: 'Honey PayPal logo',
  [ImageSrcs.PaypalLogo]: 'PayPal logo',
  [ImageSrcs.TrashCan]: 'Trash can',
  [ImageSrcs.WarningSign]: 'Warning sign',
  [ImageSrcs.WhiteBlackHoneyInitial]: 'Honey logo initial',
};

/* Honey UI toolkit button statuses https://dash.joinhoney.com/docs/honey-storybook/index.html?path=/story/button--props */
export enum ButtonStatus {
  Default = '',
  Disabled = 'disabled',
  Loading = 'loading',
  Success = 'success',
  Failed = 'failed',
}

export const STATE_CACHE_TTL_SECONDS = 1 * 60 * 1000;
export const PL2GO_HIDE_INTERVAL = 120 * 60 * 1000;

/* eslint-disable max-len */
export enum ErrorMessages {
  Generic = 'Hmm, something went wrong. Please check back soon.',
  CreatingOrder = 'There was an error creating your order. Please try again later.',
  GuestPaymentDisabledForMerchant = 'We’re sorry, we were unable to process this transaction. You can pay with PayPal, or check out directly on the merchant’s site for this order',
}
/* eslint-enable max-len */

export enum FeatureFlags {
  AccountLinkingEnabled = 'honey_checkout_account_linking_enabled',
  BurnGoldEnabled = 'honey_checkout_burn_gold_enabled',
  CheckoutEnabled = 'honey_checkout_enabled',
  /* previously called paypal guest, keep legacy flag name: */
  LoggedOutEnabled = 'honey_checkout_logged_out_enabled',
  NativePaypalGuestEnabled = 'honey_checkout_native_paypal_guest_enabled',
  PaypalMemberEnabled = 'honey_checkout_paypal_member_enabled',
  PaypalPayLaterEnabled = 'honey_checkout_paypal_pay_later_enabled',
  PaypalV4Enabled = 'honey_checkout_sdk_4_enabled',
  PaypalV5Enabled = 'honey_checkout_sdk_5_enabled',
  PaypalVccCartChipEnabled = 'honey_checkout_paypal_vcc_cart_chip_enabled',
  PaypalVccCartEnabled = 'honey_checkout_paypal_vcc_cart_enabled',
  PaypalVccEnabled = 'honey_checkout_paypal_vcc_enabled',
  PaypalVccHideHookUponClose = 'honey_checkout_paypal_vcc_hide_hook_upon_close',
  Pi4AccountNumberRequired = 'honey_checkout_pi_4_account_number_required',
  HookV2 = 'honey_checkout_hook_v_2',
  CheckoutHookChipEnabled = 'honey_checkout_chip_enabled',
  FireFoxEnabled = 'honey_checkout_firefox_enabled',
  SafariEnabled = 'honey_checkout_safari_enabled',
  UnifiedRewardsEnabled = 'shopping_web_unified_rewards',
  PayPalOneClickCheckoutEnabled = 'hxo_one_click_checkout_enabled',
}

export enum Touchpoints {
  PaypalPL2GoContent = 'PAYPAL_PL2GO_CONTENT',
  SelectCheckoutMethod = 'HNY_CHECKOUT_SELECT_METHOD',
}

export const payLaterInitEligibilityApplicationContext = [
  {
    name: 'flow',
    value: 'OFFER_PRESENTMENT',
  },
  {
    name: 'CHANNEL',
    value: 'CREDIT_MERCHANT_FRONT_OFFERS',
  },
  {
    name: 'credit_product_identifier',
    value: 'ALL',
  },
  {
    name: 'transaction_currency',
    value: 'USD',
  },
];

export const payLaterInitIdentityContext = [];

export enum ActiveExperiments {
  SelectCheckoutMethodVariant = 'honey_checkout_select_checkout_method_variant',
  OneClickCheckout = 'one_click_checkout',
  HookRedesign = 'honey_checkout_hook_redesign',
  PL2GoRamp = 'pl2go_ramp',
  MaxCashBack = 'max_cash_back_for_ppc',
  QuantumLeapContentUpdates = 'extension_quantumleap_content_updates',
}

export enum SelectCheckoutMethodVariants {
  RadioButtons = 'control',
  StackedButtons = 'stacked',
}

export enum EligibilityReasons {
  BrowserNotSupported = 'browser-not-supported',
  CartPriceOutOfRange = 'cart-price-out-of-range',
  CartPriceMissing = 'cart-price-not-found',
  CartPriceIsZero = 'cart-price-is-zero',
  DisabledForAllUsers = 'checkout-disabled-for-all-users',
  DisabledForLoggedOutUsers = 'checkout-disabled-for-logged-out-users',
  EligibilityCountThrottled = 'eligibility-count-throttled',
  RefreshThrottled = 'refresh-throttled',
  ExtensionVersionNotSupported = 'extension-version-not-supported',
  FailedConnectingToSPB = 'failed-connecting-to-spb',
  FailedGettingMerchantPaypalSDKVersion = 'failed-getting-merchant-paypal-sdk-version',
  FailedGettingMerchantPaypalOrderConfig = 'failed-getting-merchant-paypal-order-config',
  FailedGettingSPBCommit = 'failed-getting-spb-commit',
  IsPayPalUser = 'is-paypal-user',
  MerchantFailedReturningOrderId = 'merchant-failed-returning-order-id',
  NotStarted = 'eligibility-check-not-started',
  PaypalSDKVersion4Disabled = 'paypal-sdk-version-4-disabled',
  PaypalSDKVersion5Disabled = 'paypal-sdk-version-5-disabled',
  UserAlreadyApproved = 'user-already-approved',
  PaypalVccCartDisabled = 'paypal-vcc-cart-disabled',
  PaypalVccDisabled = 'paypal-vcc-disabled',
  PL2GoCartConfigDisabled = 'pl2go-vcc-cart-config-disabled',
  StoreIdNotDetected = 'store-id-not-detected',
  UserDisabledCartPresentmentHook = 'user-disabled-cart-presentment-hook',
  UserClosedCheckoutHook = 'user-closed-checkout-hook',
  UserDisabledCheckoutHook = 'user-disabled-checkout-hook',
  UserDismissedFsacc = 'user-dismissed-fsacc',
  UserHidPL2GoHook = 'user-hid-pl2go-hook',
  UserDisabledPL2GoHook = 'user-disabled-pl2go-hook',
  UserInControlExperimentGroup = 'user-in-experiment-control-group',
  UserPassedEligibility = 'user-passed-eligibility',
}

export enum LinkUrls {
  GoldBurnRewardsTerms = 'https://www.paypal.com/us/webapps/mpp/ua/pp-rewards-program-tnc',
  GoldBurnEligibleItemTerms = 'https://help.joinhoney.com/category/341-honey-checkout',
  HoneyPrivacyPolicy = 'https://www.joinhoney.com/privacy',
  HoneyTermsOfUse = 'https://www.joinhoney.com/terms',
  PaypalBuyerProtection = 'https://www.paypal.com/us/legalhub/buyer-protection?locale.x=en_US ',
}

export const GOLD_BURN_MIN_GOLD = 100;


export enum CheckoutTypes {
  SPB = 'SPB',
  StaticPaypalButton = 'StaticPaypalButton',
  VCC = 'VCC',
  CartPresentment = 'CartPresentment',
}

export const isPaypalStaticButtonCheckoutType = (t: CheckoutTypes): t is CheckoutTypes.StaticPaypalButton => t === CheckoutTypes.StaticPaypalButton;
export const isVccCheckoutType = (t: CheckoutTypes): t is CheckoutTypes.VCC => t === CheckoutTypes.VCC;
export const isSPBCheckoutType = (t: CheckoutTypes): t is CheckoutTypes.SPB => t === CheckoutTypes.SPB;
export const isCartPresentmentCheckoutType = (t: CheckoutTypes): t is CheckoutTypes.CartPresentment => t === CheckoutTypes.CartPresentment;

export enum PL2GoCreditSessionStatus {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  REFOCUS = 'REFOCUS',
}

export enum RewardsTypes {
  CASH_BACK = 'back',
  HONEY_GOLD = 'Honey Gold',
}
